import type { SelectOption } from '@atlassian/jira-issue-field-select';
import { MUTATION_GROUP } from './constants';
import type { JiraSingleSelectFieldInput } from './types';

export const mutateSingleSelectField = (
	{ value }: SelectOption,
	fieldId: string,
): JiraSingleSelectFieldInput => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	option: { optionId: value },
});

export const mapSelectOptionsToConnectData = (option: SelectOption): string => option.value;
